import ldFlags from 'constants/ldFlags';

export interface IFeatureFlag {
    [key: string]: boolean;
}
export const isEnabledFeatureFlag = (allFeatureFlags: IFeatureFlag, flagName: string): boolean =>
    allFeatureFlags[flagName];

export const isIncomingTransferFeatureEnabled = (allFeatureFlags: IFeatureFlag): boolean =>
    isEnabledFeatureFlag(allFeatureFlags, ldFlags.enabledIncomingTransfer);

export default {
    isEnabledFeatureFlag,
    isIncomingTransferFeatureEnabled,
};
